import { getApiError } from '~/api/problem'
import { ApplicantErrorType } from './errors'

export type AccessDeniedAgency = { id: number; name: string }

/** Agencies holding the applicant, read from the `agencies` extension of an applicant 403 */
export const applicantAccessDeniedAgencies = (
  error: unknown
): AccessDeniedAgency[] | undefined => {
  const problem = getApiError(error)

  if (problem?.type !== ApplicantErrorType.AccessDenied) {
    return undefined
  }

  return Array.isArray(problem.extensions.agencies)
    ? problem.extensions.agencies
    : undefined
}

/** Wording of a 403 on an applicant, from the agencies the API attaches to it */
export const applicantAccessDeniedMessage = (
  agencies?: AccessDeniedAgency[]
): string => {
  if (!agencies || agencies.length === 0) {
    return "Vous n'avez pas accès à ce candidat."
  }
  const names = agencies.map((agency) => agency.name).join(', ')
  return agencies.length === 1
    ? `Ce candidat est rattaché à l'agence : ${names}.`
    : `Ce candidat est rattaché aux agences : ${names}.`
}
